import { useGetWaveSpectraQuery } from '../../../../../../queries/useGetWaveSpectraQuery';
import { useGetWaveSpectraTimeseriesQuery } from '../../../../../../queries/useGetWaveSpectraTimeseriesQuery';
import { useWaveSpectraParams } from '../../../hooks/useWaveSpectraParams';
import { UpdateButton } from '../../common/UpdateButton';
import { AnalyticsSection } from '../../Layout/AnalyticsSection';
import { WaveSpectraChart } from './WaveSpectraChart';
import { WaveSpectraInputForm } from './WaveSpectraInputForm';

export const WaveSpectra = () => {
  const {
    datasets,
    datasetId,
    onDatasetChange,
    dateRange,
    submittedParams,
    canUpdate,
    onUpdate,
    isWaveSpectraAvailable,
    isSpectraCoverageMissing,
    orderId,
    pointName,
    timeseriesVariable,
    isDateRangeBlocked,
    spectraBlockedMessage,
  } = useWaveSpectraParams();

  const { data, error, isFetching } = useGetWaveSpectraQuery(submittedParams);

  const {
    data: timeseries,
    error: timeseriesError,
    isFetching: isTimeseriesFetching,
  } = useGetWaveSpectraTimeseriesQuery({
    spectraData: data,
    params: submittedParams,
    orderId,
    pointName,
    variable: timeseriesVariable,
  });

  const chartError = error ?? timeseriesError;
  const isChartFetching = isFetching || isTimeseriesFetching;

  return (
    <AnalyticsSection
      plotInputContent={
        <WaveSpectraInputForm
          datasets={datasets}
          datasetId={datasetId}
          onDatasetChange={onDatasetChange}
          dateRange={dateRange}
          isLoading={isChartFetching}
          isAvailable={isWaveSpectraAvailable}
        />
      }
      updateContent={
        <UpdateButton onClick={onUpdate} loading={isChartFetching} disabled={!canUpdate} />
      }
      chartContent={
        <WaveSpectraChart
          data={data}
          timeseries={timeseries ?? null}
          error={chartError}
          isFetching={isChartFetching}
          hasSubmitted={!!submittedParams}
          isAvailable={isWaveSpectraAvailable}
          isSpectraCoverageMissing={isSpectraCoverageMissing}
          isDateRangeBlocked={isDateRangeBlocked}
          spectraBlockedMessage={spectraBlockedMessage}
        />
      }
      isLoading={isChartFetching}
    />
  );
};
